interface PathsType {
    admin: string;
    login: string;
    migrate: string;
    create: string;
    root: string;
    rums: string;
    inventory: string;
    api: {
        user: string;
        login: string;
        logout: string;
        migrate: string;
        create: string;
    };
}

const Paths: PathsType = {
    admin: "/admin",
    login: "/login",
    migrate: "/migrate",
    create: "/create",
    root: "/",
    rums: "/rums",
    inventory: "/inventory",
    api: {
        user: "/get-user",
        login: "/api-token-auth",
        logout: '/get-user',
        migrate: '/migrate-user',
        create: '/create-user'
    }
};

export default Paths;
